import React from 'react';
import styled from 'styled-components';
import { Divider } from 'styled_components/Common/Divider';

const SwitchDisplayStyle = styled.div`
	width: 100%;
	height: 212px;
	display: flex;
	flex-direction: column;
	padding: 10px;
	max-height: 212px;
	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};

	.row {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		flex: 1;
		text-align: center;
		cursor: pointer;
		&.selected {
			.name {
				width: 200px;
				height: 75px;
				background-color: #00ad5c;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 5px;
				font-size: 23px;
				color: ${props => props.theme.white};
			}
		}

		.label {
			width: 100%;
			//width: 100px;
		}
	}

	.value {
		display: flex;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.row {
			height: 52px;
			.label {
				width: 150px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		padding: 20px;
		.row {
			height: 80px;
			.label {
				width: 150px;
			}
		}
	}
`;

export const Switch = ({ id, setSelected, selected }) => {
	return (
		<SwitchDisplayStyle
			id={`split-info-display-${id}`}
			className='status-display'
			data-cy='status-display'
		>
			<div
				className={selected === 'power' ? 'row selected' : 'row'}
				onClick={() => setSelected('power')}
			>
				<div className='name heading60'>Power</div>
			</div>
			<div
				className={selected === 'network' ? 'row selected' : 'row'}
				onClick={() => setSelected('network')}
			>
				<Divider />

				<div className='name heading60'>Network</div>
			</div>
		</SwitchDisplayStyle>
	);
};
